import React, { useRef } from 'react';
import MaterialTable, { MTableToolbar } from 'material-table';
import { TextField, Typography } from '@material-ui/core';
import moment from 'moment';
import { FieldArray, Form, Formik } from 'formik';
import gql from 'graphql-tag';
import { useMutation, useQuery } from '@apollo/client';
import LoadingView from '../../components/LoadingView';
import {
  ADD_OTHER_LEASE_TITLE,
  REMOVE_OTHER_LEASE_TITLE,
  UPDATE_OTHER_LEASE_TITLE,
} from '../../components/otherleases/otherleaseQueries';

const titleQuery = gql`
  query OtherLease($id: ID!) {
    OtherLease(id: $id) {
      id
      projectName
      titleRun {
        id
        volPage
        effectiveDate
        dateFiled
        comments
        grantor
        grantee
      }
    }
  }
`;

const OtherLeaseTitle = ({ history, match, enqueueSnackbar }) => {
  const [addTitle] = useMutation(ADD_OTHER_LEASE_TITLE);
  const [deleteTitle] = useMutation(REMOVE_OTHER_LEASE_TITLE);
  const [editTitle] = useMutation(UPDATE_OTHER_LEASE_TITLE);
  const tableRef = useRef(null);
  const [highlightedRowID, setHighlightedRow] = React.useState();

  const { data, loading, error } = useQuery(titleQuery, {
    variables: { id: match.params.OtherLeaseID },
  });

  if (loading) {
    return <LoadingView />;
  }
  if (error) {
    return error.toString();
  }

  const OtherLease = data.OtherLease[0] || [];

  return (
    <div>
      <Formik onSubmit={() => {}} initialValues={OtherLease}>
        {(props) => (
          <Form>
            <FieldArray name='titleRun'>
              {({ push, remove, insert }) => {
                const columns = [
                  {
                    title: 'Vol/Page',
                    field: 'volPage',
                    cellStyle: {
                      whiteSpace: 'nowrap',
                    },
                  },
                  {
                    title: 'Date Filed',
                    field: 'dateFiled',
                    render: (rowData) => moment(rowData.dateFiled).format('MM/DD/YYYY'),
                    // Keep in case we need
                    // customSort: (a, b) => (moment(a.dateFiled).isAfter(moment(b.dateFiled)) ? 1 : -1),
                    defaultSort: 'asc',
                    editComponent: (props) => (
                      <TextField type='date' onChange={(e) => props.onChange(e.target.value)} />
                    ),
                  },
                  {
                    title: 'Effective Date',
                    field: 'effectiveDate',
                    render: (rowData) => moment(rowData.effectiveDate).format('MM/DD/YYYY'),
                    editComponent: (props) => (
                      <TextField type='date' onChange={(e) => props.onChange(e.target.value)} />
                    ),
                  },
                  {
                    title: 'Grantor',
                    field: 'grantor',
                  },
                  {
                    title: 'Grantee',
                    field: 'grantee',
                    cellStyle: {
                      whiteSpace: 'nowrap',
                    },
                  },
                  {
                    title: 'Comments',
                    field: 'comments',
                  },
                ];

                return (
                  <MaterialTable
                    columns={columns}
                    data={props.values.titleRun.map(w => ({...w}))}
                    // data={props.values.titleRun}
                    icons={{
                      Add: props => (
                        <div id="myChain" ref={tableRef} hidden>
                        </div>
                      ),
                    }}
                    components={{
                      Toolbar: (props) => (
                        <div
                          style={{
                            backgroundColor: '#1976d2',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            // padding: '0 16px',
                            height: '60px',
                          }}
                        >
                          <MTableToolbar {...props} />
                        </div>
                      ),
                    }}
                    options={{
                      maxBodyHeight: 'calc(100vh - 150px)',
                      initialPage: 0,
                      paging: false,
                      searchFieldAlignment: 'left',
                      searchFieldStyle: {
                        backgroundColor: '#fff',
                        color: '#000',
                        border: 'none',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        paddingLeft: '8px',
                        paddingRight: '8px',
                        borderRadius: '4px',
                      },
                      showTitle: false,
                      toolbarButtonAlignment: 'left',
                      addRowPosition: 'first',
                      exportButton: true,
                      headerStyle: {
                        backgroundColor: '#1976d2',
                        color: '#FFF',
                        textAlign: 'left',
                        justifyContent: 'center',
                        whiteSpace: 'pre',
                        // position: 'fixed',
                      },
                      rowStyle: (rowData) => ({
                        backgroundColor:
                          rowData.tableData?.id === highlightedRowID ? '#c5c5c5' : 'white',
                        transition: 'background-color 0.3s ease',
                      }),
                    }}
                    editable={{
                      onRowAdd: (newData) => {
                        return addTitle({
                          variables: {
                            LeaseID: props.values.id,
                            info: { ...newData },
                          },
                        })
                          .then(({ data: { addOtherLeaseTitle } }) => {
                            push(addOtherLeaseTitle.titleRun[0]);
                          })
                          .catch((error) => console.log(error));
                      },
                      onRowUpdate: (newData, oldData) => {
                        const { __typename, id, ...updateData } = newData;
                        return editTitle({
                          variables: {
                            OtherLeaseTitleID: oldData.id,
                            info: { ...updateData },
                          },
                        }).then(({ data: { updateOtherLeaseTitle } }) => {
                          remove(oldData.tableData.id);
                          insert(oldData.tableData.id, updateOtherLeaseTitle.titleRun[0]);
                        });
                      },
                      onRowDelete: (oldData) => {
                        return deleteTitle({
                          variables: {
                            OtherLeaseTitleID: oldData.id,
                          },
                        })
                          .then((data) => {
                            remove(oldData.tableData.id);
                          })
                          .catch((error) => console.log(error));
                      },
                    }}
                  />
                );
              }}
            </FieldArray>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default OtherLeaseTitle;
